import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

function PortfolioManagment () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <p className="text-[24px] xl:text-[48px] manrope leading-[1.2] font-[500] xl:max-w-[419px]">{t('home.32')}</p>
                <div className="flex flex-col xl:flex-row gap-[80px] justify-between mt-[20px] xl:mt-[40px]">
                    <div className="flex flex-col items-start">
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px] xl:max-w-[497px]">{t('home.33')}</p>
                        <p className="text-[#000000B2] roboto font-[300] text-[12px] xl:text-[14px] xl:max-w-[497px] mt-[12px] xl:mt-[20px]">{t('home.34')}</p>
                        <Button className={"mt-[30px] xl:mt-[40px]"}/>
                    </div>
                    <div className="flex flex-col gap-[6px] xl:gap-[14px]">
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.35')}</p>
                        </div>
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.36')}</p>
                        </div>
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.37')}</p>
                        </div>
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.38')}</p>
                        </div>
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.39')}</p>
                        </div>
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.40')}</p>
                        </div>
                        <div className="flex gap-[14px] xl:gap-[22px]">
                            <div className="w-[4px] h-[4px] xl:w-[6px] xl:h-[6px] bg-black rounded-full flex-shrink-0 mt-[8px]"></div>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('home.41')}</p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    );
}

export default PortfolioManagment;